import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useUserProfileAnalytics(userId: string, from: Date, to: Date) {
  return useQuery({
    queryKey: ["user-profile-analytics", userId, from, to],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("user_profile_analytics", {
        p_user_id: userId,
        p_from: from.toISOString().slice(0, 10),
        p_to: to.toISOString().slice(0, 10),
      });
      if (error) throw error;
      return data;
    },
    enabled: !!userId && !!from && !!to,
  });
} 